module.exports = __webpack_public_path__ + "img/img_23.9e8fe21e.png";